import { useCallback, useEffect, useState } from 'react'
import { callSageApi } from './api'

export const useSnapshot = ({ patientId, snapshotMode, skip = false }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [errors, setErrors] = useState([])
  const [refetchCount, setRefetchCount] = useState(0)

  const refetch = useCallback(() => setRefetchCount((c) => c + 1), [])

  useEffect(
    () => {
      if (skip || !patientId) {
        setLoading(false)
        return
      }
      async function fetch() {
        try {
          setLoading(true)
          setErrors([])
          const response = await callSageApi({
            path: `/api/v1/${patientId}/snapshots/structured`,
            params: { snapshot_mode: snapshotMode },
            method: 'GET',
          })
          setData(response?.data || [])
        } catch (error) {
          setErrors([error])
        } finally {
          setLoading(false)
        }
      }
      fetch()
    },
    // eslint-disable-next-line
    [patientId, snapshotMode, skip, refetchCount],
  )

  return {
    data,
    loading,
    errors,
    refetch,
  }
}
